// AI-generated code - 2026-02-02T13:50:40Z
import { type ApiOrder } from '@Model';
import { useMemo } from 'react';

export function useOrderTotals(apiOrder: ApiOrder) {
    return useMemo(() => {
        const totalGrossPrice = apiOrder.positions.reduce((prev, current) => prev + current.total_gross_price, 0);
        const totalNetPrice = apiOrder.positions.reduce((prev, current) => prev + current.total_net_price, 0);

        return {
            totalGrossPrice,
            totalNetPrice,
        };
    }, [apiOrder.positions]);
}
